export abstract class Environment {
    abstract readonly production: boolean
    abstract readonly version: string
    abstract readonly sentryDSN: string
}
